import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  Building2,
  Wrench,
  BarChart3,
  Shield,
  Cable,
  BookOpen,
  ThumbsUp,
  LayoutDashboard,
  Globe,
} from 'lucide-react';
import { Activity } from 'lucide-react';
import { cn } from '@/lib/utils';

interface AdminSection {
  label: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
  sysAdminOnly?: boolean;
}

const SECTIONS: AdminSection[] = [
  { label: 'Dashboard', href: '/admin', icon: LayoutDashboard },
  { label: 'Organizations', href: '/admin/organizations', icon: Building2 },
  { label: 'Entitlements', href: '/admin/entitlements', icon: Shield },
  { label: 'Tool Registry', href: '/admin/tools', icon: Wrench },
  {
    label: 'Source Registration',
    href: '/admin/source-registration',
    icon: Globe,
    sysAdminOnly: true,
  },
  { label: 'Engine Connections', href: '/admin/engines', icon: Cable },
  { label: 'Skills', href: '/admin/skills', icon: BookOpen },
  { label: 'Analytics', href: '/admin/analytics', icon: BarChart3 },
  {
    label: 'Feedback',
    href: '/admin/feedback',
    icon: ThumbsUp,
    sysAdminOnly: true,
  },
  {
    label: 'Log Monitor',
    href: '/admin/logs',
    icon: Activity,
    sysAdminOnly: true,
  },
  { label: 'System', href: '/admin/system', icon: Shield },
];

export const AdminNav: React.FC<{ isSysAdmin: boolean }> = ({ isSysAdmin }) => (
  <nav className="flex flex-wrap gap-1 rounded-md bg-muted p-1 w-fit">
    {SECTIONS.filter((s) => !s.sysAdminOnly || isSysAdmin).map(
      ({ label, href, icon: Icon }) => (
        <NavLink
          key={href}
          to={href}
          end={href === '/admin'}
          className={({ isActive }) =>
            cn(
              'inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium transition-all',
              isActive
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            )
          }
        >
          <Icon className="w-4 h-4 mr-2" />
          {label}
        </NavLink>
      )
    )}
  </nav>
);
